'use client';

import React from 'react';
import { Play, Star, ClipboardList, Gamepad2 } from 'lucide-react';
import Image from 'next/image';

interface WelcomePhaseProps {
  onPlay: () => void;
}

export default function WelcomePhase({ onPlay }: WelcomePhaseProps) {
  return (
    <div className="animate-fade-in">
      {/* Logo */}
      <div className="text-center mb-8">
        <div className="flex items-center justify-center mb-4">
          <Image
            src="/assets/images/3tlogo-removebg-preview-1775658033774.png"
            alt="3T Logo"
            width={120}
            height={80}
            className="object-contain"
            priority
          />
        </div>
        <p className="text-green-600/70 text-sm font-medium mt-1 tracking-wide uppercase">
          Think fast. Guess right. Win big!
        </p>
      </div>

      {/* Main card */}
      <div className="bg-white rounded-3xl shadow-xl border border-green-100 p-8 text-center">
        {/* How it works */}
        <h2 className="text-2xl font-bold text-gray-800 mb-2">How to Play</h2>
        <p className="text-gray-500 text-sm mb-6">Three simple steps to enter the draw</p>

        <div className="space-y-4 mb-8 text-left">
          <div className="flex items-start gap-4 p-3 rounded-xl bg-green-50 border border-green-100">
            <div className="flex-shrink-0 w-9 h-9 bg-green-600 rounded-xl flex items-center justify-center">
              <ClipboardList size={18} className="text-white" />
            </div>
            <div>
              <p className="font-semibold text-gray-800 text-sm">Step 1 — Fill in your details</p>
              <p className="text-gray-500 text-xs mt-0.5">Enter your name, email, company and your number then play the game and enter your guess number.</p>
            </div>
          </div>

          <div className="flex items-start gap-4 p-3 rounded-xl bg-yellow-50 border border-yellow-100">
            <div className="flex-shrink-0 w-9 h-9 bg-yellow-500 rounded-xl flex items-center justify-center">
              <Gamepad2 size={18} className="text-white" />
            </div>
            <div>
              <p className="font-semibold text-gray-800 text-sm">Step 2 — Choose your game & play</p>
              <p className="text-gray-500 text-xs mt-0.5">Count the Manatees or Find the Manatee to play.</p>
            </div>
          </div>

          <div className="flex items-start gap-4 p-3 rounded-xl bg-green-50 border border-green-100">
            <div className="flex-shrink-0 w-9 h-9 bg-green-600 rounded-xl flex items-center justify-center">
              <Star size={18} className="text-white" fill="currentColor" />
            </div>
            <div>
              <p className="font-semibold text-gray-800 text-sm">Step 3 — Win prizes!</p>
              <p className="text-gray-500 text-xs mt-0.5">Closest guess or fastest manatee find wins. Good luck!</p>
            </div>
          </div>
        </div>

        <button
          onClick={onPlay}
          className="w-full bg-green-600 hover:bg-green-700 active:scale-95 text-white font-bold text-lg py-4 rounded-2xl shadow-lg shadow-green-200 transition-all duration-150 flex items-center justify-center gap-3 group"
        >
          <div className="w-8 h-8 bg-white/20 rounded-xl flex items-center justify-center group-hover:bg-white/30 transition-colors duration-150">
            <Play size={18} className="text-white" fill="currentColor" />
          </div>
          Enter Now
        </button>

        <p className="text-xs text-gray-400 mt-4">
          Your details will be used for event prize draws only.
        </p>
      </div>
    </div>
  );
}